import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux'
import { ThemeProvider } from '@fluentui/react-theme-provider';

import AppRouter from './AppRouter';
import { configureStore, getStore } from './store';

import { theme } from './theme';
import { getAppName } from './utils';

document.title = getAppName();

configureStore();

ReactDOM.render(
    <Provider store={getStore()}>
        <ThemeProvider theme={theme}>
            <AppRouter />
        </ThemeProvider>
    </Provider>,
    document.getElementById('root')
);
